// useShortcut.ts
import { useEffect } from "react";
import { registerShortcut, unregisterShortcut } from "../store/ShortCutManager";

export function useShortcut(key: string, action: () => void) {
  useEffect(() => {
    registerShortcut(key, action);
    return () => unregisterShortcut(key);
  }, [key, action]);
}
